import { render } from "./Activation1.vue?vue&type=template&id=4213f6a2"
import script from "./Activation1.vue?vue&type=script&lang=js"
export * from "./Activation1.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__